import 'font-awesome/css/font-awesome.css'
import Vue from 'vue'

import moment from 'moment' 
Vue.prototype.moment = moment
moment.locale('pt-br');

Vue.filter('dt_emissao', function(value) {
  if (value) {
    return moment(String(value)).format('DD/MM/YYYY HH:mm:ss')
  }
})


import App from './App'

import './config/bootstrap'
import './config/msgs'
import './config/axios'
import './config/mq'




import store from './config/store'
import router from './config/router'

Vue.config.productionTip = false

new Vue({
  store,
  router,
  render: h => h(App)
}).$mount('#app')